/**
 * Template variables available for use in email/SMS templates
 * These variables are resolved during template formatting
 */
export var CompanyTemplateVariable;
(function (CompanyTemplateVariable) {
    CompanyTemplateVariable["COMPANY_NAME"] = "[[company_name]]";
    CompanyTemplateVariable["COMPANY_WEBSITE"] = "[[company_website]]";
    CompanyTemplateVariable["COMPANY_PRIMARY_COLOR"] = "[[company_primary_color]]";
    CompanyTemplateVariable["COMPANY_LOGO_URL"] = "[[company_logo_url]]";
    CompanyTemplateVariable["COMPANY_EMAIL"] = "[[company_email]]";
    CompanyTemplateVariable["COMPANY_PHONE"] = "[[company_phone]]";
    CompanyTemplateVariable["COMPANY_EXTERNAL_ID"] = "[[company_external_id]]";
})(CompanyTemplateVariable || (CompanyTemplateVariable = {}));
//# sourceMappingURL=template-variables.js.map